<template>
  <v-container>
    <v-row class="wrap">
      <v-col md="6">
        <line-chart
          :series="addSeries"
          :categories="days"
          :options="{
            title: {
              text: 'Activations',
              offsetX: 14,
            },
          }"
          id="activation"
        />
      </v-col>
      <v-col md="6">
        <line-chart
          :series="renewSeries"
          :categories="days"
          :options="{
            title: {
              text: 'Renewals',
              offsetX: 14,
            },
          }"
          id="renewal"
        />
      </v-col>
      <v-col md="6">
        <line-chart
          :series="paymentSeries"
          :categories="days"
          id="pay"
          :options="{
            title: {
              text: 'Pay TM',
              offsetX: 14,
            },
          }"
        />
      </v-col>
      <v-col md="6">
        <line-chart
          :series="paymentEasyBuzz"
          :categories="days"
          id="pay"
          :options="{
            title: {
              text: 'Easy Buzz',
              offsetX: 14,
            },
          }"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Line from "../components/Line";
import {
  fetchAdd,
  fetchRenew,
  fetchPayments,
  fetchEasyBuzzPayments,
} from "../services/report";
import { byDate as fetchSR } from "../services/serviceRequest";

export default {
  data() {
    return {
      addSeries: [],
      addLabels: [],
      renewSeries: [],
      paymentSeries: [],
      paymentEasyBuzz: [],
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    };
  },
  components: {
    "line-chart": Line,
  },
  methods: {
    getInterval() {
      const today = new Date();
      // console.log('get interval : ', today.getMonth() + 1);
      const todayParsed =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() + 1);
      console.log("today : ", todayParsed);
      const lastSameDay = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
      const lastParsed =
        lastSameDay.getFullYear() +
        "-" +
        (lastSameDay.getMonth() + 1) +
        "-" +
        lastSameDay.getDate();
      // console.log('last date month : ', lastSameDay.getMonth() + 1);
      return [todayParsed, lastParsed];
    },
    async processActivation() {
      const [todayParsed, lastParsed] = this.getInterval();
      const payload = {
        startDate: lastParsed,
        endDate: todayParsed,
        filterBy: 5,
      };
      const result = await fetchAdd(payload);
      // console.log('add result is : ', result);
      const addSeries = [];
      const days = this.days;
      const statusMap = {};
      result.forEach((r) => {
        const { transactionDate } = r;
        const { status } = r;
        if (!(status in statusMap)) {
          statusMap[status] = new Map();
        }
        const day = days[new Date(transactionDate).getDay()];
        const daywiseAdd = statusMap[status];
        if (daywiseAdd.has(day)) {
          daywiseAdd.set(day, daywiseAdd.get(day) + 1);
        } else {
          daywiseAdd.set(day, 1);
        }
      });
      Object.keys(statusMap).forEach((status) => {
        const daywiseAdd = statusMap[status];
        addSeries.push({
          data: days.map((day) =>
            daywiseAdd.has(day) ? daywiseAdd.get(day) : 0
          ),
          name: status,
        });
      });
      this.addSeries = addSeries;
    },
    async processRenewal() {
      const [todayParsed, lastParsed] = this.getInterval();
      const payload = {
        startDate: lastParsed,
        endDate: todayParsed,
        filterBy: 5,
      };
      const result = await fetchRenew(payload);
      // console.log('renew result is : ', result);
      const renewSeries = [];
      const days = this.days;
      const statusMap = {};
      result.forEach((r) => {
        const { transactionDate } = r;
        const { status } = r;
        if (!(status in statusMap)) {
          statusMap[status] = new Map();
        }
        const day = days[new Date(transactionDate).getDay()];
        const daywiseAdd = statusMap[status];
        if (daywiseAdd.has(day)) {
          daywiseAdd.set(day, daywiseAdd.get(day) + 1);
        } else {
          daywiseAdd.set(day, 1);
        }
      });
      Object.keys(statusMap).forEach((status) => {
        const daywiseAdd = statusMap[status];
        renewSeries.push({
          data: days.map((day) =>
            daywiseAdd.has(day) ? daywiseAdd.get(day) : 0
          ),
          name: status,
        });
      });
      this.renewSeries = renewSeries;
    },
    async processPayments() {
      try {
        const [todayParsed, lastParsed] = this.getInterval();
        const payload = {
          startDate: lastParsed,
          endDate: todayParsed,
          filterBy: 5,
        };
        const result = await fetchPayments(payload);
        const paymentSeries = [];
        const days = this.days;
        const statusMap = {};
        result.forEach((r) => {
          const { trancationDate: transactionDate } = r;
          const { status } = r;
          if (!(status in statusMap)) {
            statusMap[status] = new Map();
          }
          const day = days[new Date(transactionDate).getDay()];
          const daywiseAdd = statusMap[status];
          if (daywiseAdd.has(day)) {
            daywiseAdd.set(day, daywiseAdd.get(day) + 1);
          } else {
            daywiseAdd.set(day, 1);
          }
        });
        Object.keys(statusMap).forEach((status) => {
          const daywiseAdd = statusMap[status];
          paymentSeries.push({
            data: days.map((day) =>
              daywiseAdd.has(day) ? daywiseAdd.get(day) : 0
            ),
            name: status,
          });
        });
        this.paymentSeries = paymentSeries;
      } catch (err) {
        // console.log(err);
      }
    },
    async processEasyBuzzPayments() {
      try {
        const [todayParsed, lastParsed] = this.getInterval();
        const payload = {
          startDate: lastParsed,
          endDate: todayParsed,
          filterBy: 5,
        };
        const result = await fetchEasyBuzzPayments(payload);
        const paymentEasyBuzz = [];
        const days = this.days;
        const statusMap = {};
        result.forEach((r) => {
          const { trancationDate: transactionDate } = r;
          const { status } = r;
          if (!(status in statusMap)) {
            statusMap[status] = new Map();
          }
          const day = days[new Date(transactionDate).getDay()];
          const daywiseAdd = statusMap[status];
          if (daywiseAdd.has(day)) {
            daywiseAdd.set(day, daywiseAdd.get(day) + 1);
          } else {
            daywiseAdd.set(day, 1);
          }
        });
        Object.keys(statusMap).forEach((status) => {
          const daywiseAdd = statusMap[status];
          paymentEasyBuzz.push({
            data: days.map((day) =>
              daywiseAdd.has(day) ? daywiseAdd.get(day) : 0
            ),
            name: status,
          });
        });
        this.paymentEasyBuzz = paymentEasyBuzz;
      } catch (err) {
        // console.log(err);
      }
    },
    async processSR() {
      console.log("process SR");
      try {
        const [todayParsed, lastParsed] = this.getInterval();
        const payload = {
          startDate: lastParsed,
          endDate: todayParsed,
          filterBy: 5,
        };
        const result = await fetchSR(payload);
        console.log("SR result : ", result);
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    this.processActivation();
    this.processRenewal();
    this.processPayments();
    this.processEasyBuzzPayments();
    this.processSR();
  },
};
</script>

<style scoped>
.wrap {
  margin: 1rem 0rem !important;
}
</style>
